import { Link } from "react-router-dom";
import EventCard from "@/components/base/EventCard";
import { categories, events } from "@/mocks/events";

export default function EventGrid() {
  const list = events.slice(0, 6);

  return (
    <div>
      <div className="mb-6 flex flex-wrap gap-2">
        {categories.map((c) => (
          <Link
            key={c.key}
            to={c.key === "all" ? "/events" : `/events?cat=${c.key}`}
            className="inline-flex items-center gap-1.5 whitespace-nowrap rounded-full border border-background-200 bg-background-50 px-3.5 py-2 text-sm font-medium text-foreground-700 transition-colors hover:border-primary-300 hover:bg-primary-50 hover:text-primary-700"
          >
            <i className={`${c.icon} text-base`}></i>
            {c.name}
          </Link>
        ))}
      </div>

      <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
        {list.map((item) => (
          <EventCard key={item.id} event={item} />
        ))}
      </div>
    </div>
  );
}